import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();

// ===== Global Draggable Modals =====
// 모든 모달(position:fixed 오버레이 > 내부 박스)의 헤더 영역을 드래그 가능하게 만듦
(function() {
  let dragState = null;

  function findModalBox(el) {
    // 오버레이(position:fixed) 바로 안의 첫 자식(모달 박스)을 찾음
    while (el) {
      const parent = el.parentElement;
      if (parent && parent.style.position === 'fixed' && parent.style.inset === '0px') {
        return el;
      }
      el = el.parentElement;
    }
    return null;
  }

  function isModalHeader(el) {
    // borderBottom이 있고 fontWeight가 700인 div = 모달 헤더
    if (!el || el.tagName !== 'DIV') return false;
    const style = window.getComputedStyle(el);
    if (style.fontWeight === '700' && style.borderBottomStyle !== 'none' && style.cursor !== 'pointer') {
      const box = findModalBox(el);
      if (box) return true;
    }
    return false;
  }

  document.addEventListener('mousedown', function(e) {
    if (['INPUT','TEXTAREA','SELECT','BUTTON','A','SPAN'].includes(e.target.tagName)) return;

    // 헤더 div 자체이거나 바로 부모가 헤더인 경우
    let header = e.target;
    if (!isModalHeader(header)) header = header.parentElement;
    if (!isModalHeader(header)) return;

    const box = findModalBox(header);
    if (!box) return;

    // 이미 transform이 있으면 파싱
    const match = box.style.transform?.match(/translate\((-?\d+)px,\s*(-?\d+)px\)/);
    const startX = match ? parseInt(match[1]) : 0;
    const startY = match ? parseInt(match[2]) : 0;

    dragState = {
      box,
      header,
      startMouseX: e.clientX,
      startMouseY: e.clientY,
      startX,
      startY,
    };
    header.style.cursor = 'grabbing';
    e.preventDefault();
  });

  document.addEventListener('mousemove', function(e) {
    if (!dragState) return;
    const dx = e.clientX - dragState.startMouseX;
    const dy = e.clientY - dragState.startMouseY;
    dragState.box.style.transform = `translate(${dragState.startX + dx}px, ${dragState.startY + dy}px)`;
  });

  document.addEventListener('mouseup', function() {
    if (!dragState) return;
    dragState.header.style.cursor = 'grab';
    dragState = null;
  });

  // 모달 헤더에 grab 커서 자동 적용 (MutationObserver로 새 모달 감지)
  const observer = new MutationObserver(function() {
    document.querySelectorAll('div[style*="position: fixed"]').forEach(function(overlay) {
      if (overlay.style.inset !== '0px') return;
      const box = overlay.children[0];
      if (!box || box.dataset.dragReady) return;
      box.dataset.dragReady = 'true';
      const header = box.children[0];
      if (header && header.tagName === 'DIV') {
        const style = window.getComputedStyle(header);
        if (style.fontWeight === '700' && style.borderBottomStyle !== 'none') {
          header.style.cursor = 'grab';
          header.style.userSelect = 'none';
        }
      }
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
